import { CustomHeader } from 'components/universal/custom-header';
import { useTranslation } from 'react-i18next';
import { RegisterChoosePageView } from 'views/register-choose';

export const RegistrationChoice = () => {
    const { t } = useTranslation('', {
        keyPrefix: 'SEO.registrationChoice',
    });

    return (
        <>
            <CustomHeader title={t('title')} />
            <RegisterChoosePageView />
        </>
    );
};
